import request from '@/utils/request'

/**
 * 查询家政服务支付列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool/queryHousekeepingServPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}